import "./App.scss";
import "swagger-ui-react/swagger-ui.css";
import "../src/Assets/graphiql.min.css";
import '@six-group/ui-library/dist/ui-library/ui-library.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);